import { LevelPlaySlide as Activity } from '.'

export const SLUG = 'slide'
export const activity = {
  SLUG,
  Component: Activity
}
